import {useEffect, useRef, useState} from "react";
import projectUtils from "../../../../../utils/project-utils.js";
import Swal from "sweetalert2";
import AttachShow from "../../../../../components/attach/attach-show.jsx";
import Button from "../../../../../components/button/button.jsx";
import {FaEye, FaPaperclip} from "react-icons/fa";

const DecreaseTermCellRenderer = ({data, setCautions, setOpenModalDecreaseTerm, canAttachDecreaseTerm}) => {
    const inputRef = useRef(null);
    const [openModal, setOpenModal] = useState(false);
    const file = data?.decrease_term_file ?? null;
    const canAttach = canAttachDecreaseTerm(data);

    useEffect(() => {
        setOpenModalDecreaseTerm(openModal)

        return () => setOpenModalDecreaseTerm(false)
    }, [openModal, setOpenModalDecreaseTerm]);

    const setFile = (decreaseTermFile) => {
        setCautions(prev => prev.map(m => m.id === data.id ? ({...m, decrease_term_file: decreaseTermFile}) : m))
    }

    const attach = () => {
        if (!canAttach) return;

        inputRef.current.click();
    }

    const handleFileChange = ({target}) => {
        const fileUploaded = target.files[0];
        target.value = "";

        if (!fileUploaded) return;

        if (fileUploaded.size > 2000000) {
            projectUtils.swalErrorMessage('', `Tamanho máximo de arquivo excedido. Limite: 2MB`, 'Ok');
            return;
        }

        const extension = fileUploaded.type.split('/')[1] || fileUploaded.name.split('.').pop();
        const newFile = new File([fileUploaded], `attach-decrease-term-${data.id}.${extension}`, {type: fileUploaded.type});

        setFile(newFile);
        setOpenModal(true);
    }

    const remove = () => {
        Swal.fire({
            title: "Excluir",
            text: 'Deseja excluir o anexo?',
            icon: "warning",
            confirmButtonText: "Sim",
            cancelButtonColor: "#c10007",
            cancelButtonText: "Não",
            confirmButtonColor: "#063A6C",
            showCancelButton: true,
            reverseButtons: true,
        }).then(({isConfirmed}) => {
            if (isConfirmed) {
                setFile(null)
                setOpenModal(false)
            }
        });
    }

    return (
        <>
            <input className="hidden" type="file" ref={inputRef} onChange={handleFileChange}
                   accept="image/png, image/jpeg, application/pdf"/>

            <div className={"flex items-center justify-center h-full"} title={canAttach ? "" : "Material sem termo de baixa habilitado"}>
                {
                    file ?
                        <Button title={"Visualizar"} target={"attached"} className={"!h-[25px] !px-2"} onClick={() => setOpenModal(true)}>
                            <FaEye />
                        </Button>
                        :
                        <Button title={"Adicionar"} target={"attach"} className={"!h-[25px] !px-2"} onClick={attach} disabled={!canAttach}>
                            <FaPaperclip />
                        </Button>
                }
            </div>

            <AttachShow
                open={openModal}
                setOpen={setOpenModal}
                remove={remove}
                attachId={null}
                newOpen={!!file}
                newFileShow={file}
                setNewOpen={() => {}}
                showRemove={canAttach}
                modalTitle={"Termo de baixa"}
            />
        </>
    );
}

export default DecreaseTermCellRenderer;